import { useEffect, useState } from 'react';

import { useUtils } from '../../utils/useUtils';

export const useMaterialSwipeableDrawer = (props, widgetName) => {
  const { getConfig } = useUtils(props, widgetName);

  const anchor = getConfig('anchor', 'bottom');
  const ctaAlignSelf = getConfig('ctaAlignSelf', 'center');
  const hideBackdrop = getConfig('hideBackdrop', false);
  const hasTopBorder = getConfig('hasTopBorder', true);
  const isDrawerInitiallyOpened = getConfig('isDrawerInitiallyOpened', false);
  const iconSrc = getConfig('iconSrc');

  const [closeIconRef, setCloseIconRef] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(isDrawerInitiallyOpened);

  useEffect(() => {
    if (isDrawerOpen && closeIconRef) {
      closeIconRef.focus();
    }
  }, [isDrawerOpen, closeIconRef]);

  return {
    anchor,
    ctaAlignSelf,
    hideBackdrop,
    iconSrc,
    isDrawerOpen,
    setCloseIconRef,
    setIsDrawerOpen,
    hasTopBorder,
    isDrawerInitiallyOpened,
  };
};
